import { IViewModeSwitchPayload } from '../actions/viewModeSwitch';
import { STATE_VIEW_MODE } from '../constants';
import { ISearchPageActionState } from '../interfaces';

export const doSetViewMode = (state: ISearchPageActionState, payload: IViewModeSwitchPayload): ISearchPageActionState => ({
    ...state,
    [STATE_VIEW_MODE]: payload[STATE_VIEW_MODE],
});
